import { useTheme } from '@mui/material';
import { SupportQueryParams } from 'features/membership/membership.types';
import { RefObject, useEffect } from 'react';

type UseCenterPlanCardProps = {
  containerRef: RefObject<HTMLDivElement | null>;
  selectedPlan?: SupportQueryParams['plan'];
  ignorePlans?: SupportQueryParams['plan'][];
};

export const useCenterPlanCard = (props: UseCenterPlanCardProps): void => {
  const { containerRef, selectedPlan, ignorePlans } = props;
  const theme = useTheme();

  useEffect(() => {
    if (!selectedPlan || ignorePlans?.includes(selectedPlan)) {
      return;
    }

    const centerCard = (): void => {
      setTimeout(() => {
        if (!containerRef.current) return;

        const selectedCard = containerRef.current.querySelector(
          `.MuiCard-root[value="${selectedPlan}"]`,
        );

        if (!selectedCard) return;

        const cardRect = selectedCard.getBoundingClientRect();
        const containerRect = containerRef.current.getBoundingClientRect();

        const cardCenter = cardRect.top + cardRect.height / 2;
        const containerCenter = containerRect.top + containerRect.height / 2;
        const scrollOffset = cardCenter - containerCenter;

        const currentScroll = containerRef.current.scrollTop;
        containerRef.current.scrollTo({
          top: currentScroll + scrollOffset,
          behavior: 'smooth',
        });
      }, theme.transitions.duration.standard);
    };

    centerCard();
  }, [
    containerRef,
    ignorePlans,
    selectedPlan,
    theme.transitions.duration.standard,
  ]);
};
